export const icons = {
	products: '/assets/images/report/products-icon.svg',
	performence: '/assets/images/report/performence-icon.svg',
	customers: '/assets/images/report/customers-icon.svg',
	certificates: '/assets/images/report/certificates-icon.svg',
	'create-pallet': '/assets/images/report/create-pallet.svg',
	'create-warehouse-w': '/assets/images/report/create-pallet.svg',
	'pallet-transfer': '/assets/images/report/pallet-transfer.svg',
	'pallet-send-out': '/assets/images/report/pallet-send-out.svg',
	'pallet-reprint': '/assets/images/report/pallet-reprint.svg',
	'pallet-warehouse': '/assets/images/report/pallet-warehouse.svg',
	'inventory-scan': '/assets/images/inventory-scan.svg',
	'pallet-info': '/assets/images/inventory-scan.svg',
	info: '/assets/images/shop-return/info-icon.svg',
	'arrow-down': '/assets/images/arrow-down-red.svg',
	'arrow-up': '/assets/images/arrow-up-green.svg',
} as const;
